import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Device, Log } from '@app/_models';
import { map, first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private http: HttpClient) { }

  getDevices(filter: object, props?: string[]) {
    const pstr = props ? 'props=' + props.join('&props=') : '';
    let fstr = stringi(filter);
    if (!pstr.length) fstr = fstr.substring(1);
    return this.http.get<Device[]>(`/api/devices?${pstr}${fstr}`).pipe(first());
  }

  getBySnOrId(sn: string, props?: string[]) {
    const pstr = props ? '?props=' + props.join('&props=') : '';
    return this.http.get<Device>(`/api/devices/${sn}${pstr}`).pipe(first());
  }

  getLogs(sn: string){
    return this.http.get<Log[]>(`/api/devices/${sn}/logs?skip=0&limit=20`).pipe(first());
  }

  getApps(sn: string){
    return this.http.get<{identifier: string,name: string,version: string,path: string,}[]>(`/api/devices/${sn}/apps`).pipe(first());
  }

  update(sn: string, params: any) {
    return this.http.put<Device>(`/api/devices/${sn}`, params).pipe(first());
  }

  add(params: any) {
    return this.http.post<Device>(`/api/devices/add`, params).pipe(first());
  }

  delete(sn: string) {
    return this.http.delete(`/api/devices/${sn}`).pipe(first());
  }

  getAdminUser(sn: string) {
    return this.getBySnOrId(sn, ['users']).pipe(map(device => {
      let userAdmin = '';
      for (let user of device.users.filter(u => u.isAdmin).map(u => u.userName)) {
        if (user == 'admin' || user == 'administrador' || user == 'administrator')
          userAdmin = user;
      }
      return userAdmin;  
    }));
  }
}

function stringi(ob: any, path = ''): string {
  if (typeof ob === 'object') {
      if (path.length) {
          if (Array.isArray(ob))
            return ob.map(v => stringi(v, `${path}[]`)).join('');
          else
            return Object.keys(ob).map(k => stringi(ob[k], `${path}[${k}]`)).join('');
      }
      else
          return Object.keys(ob).map(k => stringi(ob[k], k)).join('');
  }
  else
      return '&' + path + '=' + ob;
}
